import React, { lazy, Suspense } from 'react';
import PublicRoute from '../../../routes/PublicRoute';
import PrivateRoute from '../../../routes/PrivateRoute';
import { Spinner } from '../../Common/Spinner';
import MemberPortalListTable from './MemberPortalListTable';

const MemberPortalRouter = (props) => (
  <Suspense fallback={<Spinner />}>
    <PrivateRoute path="/member/portal/:organization_id" searchString={props.searchString} component={MemberPortalListTable} exact />
  </Suspense>
);

export default MemberPortalRouter;